import CommentBlock from './CommentBlock';

export default CommentBlock;
